import React from 'react';

import { ListItem, ListItemSecondaryAction } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Link } from 'react-router';

import { ChevronRight as ChevronRightIcon } from '../../icons';

export type NavListVariantType = 'default' | 'disabled' | 'noEndIcon';
export interface NavListItemProps {
  className?: string;
  disabled?: boolean;
  elements: JSX.Element[];
  linkCallback?: () => void;
  linkId: string;
  linkPath: string | Record<string, unknown>;
  variant?: NavListVariantType;
}

const useStyles = makeStyles((theme: Theme) => ({
  disabled: {
    color: theme.palette.text.disabled,
    cursor: 'default',
  },
  navListItem: {
    alignItems: 'center',
    color: 'inherit',
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'space-between',
    padding: theme.spacing(2.5, 2),
    textDecoration: 'none',
    width: '100%',
  },
  content: {
    alignItems: 'center',
    display: 'flex',
    width: '100%',
  },

  [theme.breakpoints.up('sm')]: {
    navListItem: {
      padding: theme.spacing(2.5, 3),
    },
  },

  [theme.breakpoints.up('md')]: {
    navListItem: {
      padding: theme.spacing(2.5, 0),
    },
  },
}));

export function NavListItem(props: NavListItemProps): JSX.Element {
  const classes = useStyles();
  const {
    className = '',
    disabled = false,
    elements,
    linkCallback,
    linkId = '',
    linkPath,
    variant = 'default',
  } = props;

  const navListItemStyles = clsx(
    classes.navListItem,
    className || '',
    disabled && classes.disabled,
  );

  return (
    <ListItem
      className={navListItemStyles}
      component={Link}
      ContainerProps={{
        className: 'fd-list__item',
      }}
      data-fd={linkId}
      disabled={variant === 'disabled'}
      key={`${linkId}-list-item`}
      onClick={linkCallback}
      role="button"
      to={linkPath}
    >
      <div className={classes.content}>
        {elements.map((element) => element)}
      </div>

      <ListItemSecondaryAction>
        {variant === 'default' && <ChevronRightIcon size="s" />}
      </ListItemSecondaryAction>
    </ListItem>
  );
}
